export default __webpack_public_path__ + "static/media/IconEvent.b4ed9a89.svg";